import React from 'react';
import SectionHeader from '../common/SectionHeader';
import Service from './services/Service';

import { ReactComponent as BackgroundImage } from '../assets/logo_infinity.svg';

import PackageImage from '../assets/home/package.jpeg';
import TPMImage from '../assets/home/tpm.jpeg';
import TailoredImage from '../assets/home/tailored.jpeg';
import MediaQuery from '../common/MediaQuery';
import { useI18n } from '../i18n/I18nContext';
import { routeIds } from '../i18n/routes';

function Services() {
  const { pathFor, t } = useI18n();

  const allServices = [
    <Service
      image={PackageImage}
      title={t("home.services.fixedPrice.title")}
      description={t("home.services.fixedPrice.description")}
      color="accent"
      corners="top-left bottom-left bottom-right"
    />,
    <Service
      image={TPMImage}
      title={t("home.services.timeAndMaterials.title")}
      description={t("home.services.timeAndMaterials.description")}
      color="primary-300"
      corners="top-left top-right bottom-left bottom-right"
    />,
    <Service
      image={TailoredImage}
      title={t("home.services.tailored.title")}
      description={t("home.services.tailored.description")}
      color="accent"
      corners="top-left top-right bottom-right"
    />
  ];
  
  return (
    <section id="services" className="relative bg-primary-500/40 content-center overflow-x-clip py-[5rem] px-10">
      <BackgroundImage aria-hidden="true" data-ambient data-parallax="35" className="infinity-art absolute text-primary-300 right-[-445px] w-[1266px] h-[654px] top-1/2 transform -translate-y-1/2 opacity-15 z-10" />
      <div className="relative max-w-[1200px] mx-auto z-20">
        <SectionHeader title={t("home.services.title")} subtitle={t("home.services.subtitle")} />
        <div className="hidden bg-accent"></div>
        <div className="hidden bg-primary-300"></div>
        <div className="flex flex-wrap justify-center py-[2.03125rem] mx-[-37.5px] w-[calc(100% + 75px)]">
          {allServices}
        </div>
        <div className="flex justify-center w-full">
          <a className="motion-button bg-accent text-white text-center font-bold rounded-full uppercase py-[1.25rem] px-[60px] transition duration-300 hover:opacity-50" href={pathFor(routeIds.contact)}>{t("common.contactUs")}</a>
        </div>
      </div>
    </section>
  );
}

export default Services;
